import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import i18nConfig from './i18n'

const i18n = createI18n(i18nConfig)

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')